import ACTIONS from '../actions';

const initialState = { isAuthenticated: false };

const auth = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.AUTH_FAIL:
            return {
                ...state,
                isAuthenticated: false
            };
        case ACTIONS.AUTH_SET_SESSION_TOKEN:
            return {
                ...state,
                token: action.token
            };
        case ACTIONS.AUTH_SUCCESS:
            return {
                ...state,
                isAuthenticated: true
            };
        case ACTIONS.APP_LOGOUT_USER:
            return {
                ...state,
                isAuthenticated: false
            };
        default:
            return state;
    }
};

export default auth;
